




























































































import { Vue, Component, Mixins } from "vue-property-decorator";

import CKEditor from "@/components/ckeditor.vue";

import TsUpload from "@/components/upload.vue";

import MyForm from "@/mixins/form";

@Component({
  components: {
    ckeditor: CKEditor,
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  handleChange() {}

  cateList = [];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确认要修改吗？",
          onOk: async () => {
            var cateIds: string[] = values.cate_ids || [];
            const res = await this.$store.dispatch("article/edit", {
              id: this.editId,
              ...values,
              cate_ids: JSON.stringify(cateIds.map((el) => parseInt(el))),
            });
            // console.log(this.$message);
            if (res && res.Message && res.Message === "success") {
              this.$message.success("修改成功");
              this.handleCancel();
            } else {
              this.$message.error("修改失败");
            }
          },
        });
      }
    });
  }

  async loadCate() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("articleCate/list");
    if (res && res.Data && res.Data.data && res.Data.data.length > 0) {
      // console.log("cate_list", res.Data);
      this.cateList = res.Data.data;
      // this.formData = res.Data;
    }

    this.spinLoading = false;
  }

  async mounted() {
    this.spinLoading = true;
    this.loadCate();
    const res = await this.$store.dispatch("article/detail", {
      id: this.editId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }

    this.spinLoading = false;
  }
}
